import Link from 'components/common/Link'

export const parseTextToLinks = text => {
    const REGEX_LINK = /\[url link=\](.*?)\[(.*?)\]/g
    let lastIndex = 0
    const elements = []

    text.replace(REGEX_LINK, (match, linkText, url, index) => {
        elements.push(text.substring(lastIndex, index))

        elements.push(
            <Link key={index} href={url} target="_blank">
                {linkText}
            </Link>
        )

        lastIndex = index + match.length
    })

    elements.push(text.substring(lastIndex))

    return elements
}
